import React, {Component, useCallback} from 'react';
import {
  StyleSheet,
  View,
  Text,
  TextInput,
  Dimensions,
  Platform,
  SafeAreaView,
  Alert,
} from 'react-native';

import networkService from '../../Network/NetworkManager';
import tableStyle from '../../StyleSheets/TableCommonStyleSheet';
import appConfigStyle from '../../StyleSheets/AppConfigStyleSheet';
import Appload from '../../HelperClasses/AppLoaderClasses/AppLoader';
import AppConstants from '../../Constants/AppConstants';
import colors from '../../HelperClasses/AppColor';
import {AppToast} from '../../HelperClasses/AppToast';
import {clearAppCustomizationDraft, readAppCustomizationDraft, writeAppCustomizationDraft} from '../../Localization/appCustomizationDrafts';

const APPURL = require('../../Constants/URLConstants');
const windowWidth = Dimensions.get('window').width;
let KeyGroup = 'general';
// const uPref = new userPref();

export default class ForceToUpdate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      switchValue: false,
      androidVersion: '',
      iosVersion: '',
      dataLoad: false,
      updateUI:false,
      ...readAppCustomizationDraft('forceUpdate'),
    };
  }
  componentDidMount() {
    this.loadConfigApi();
  }
  componentDidUpdate(previousProps, previousState) {
    if (previousState.androidVersion !== this.state.androidVersion || previousState.iosVersion !== this.state.iosVersion) writeAppCustomizationDraft('forceUpdate', this.state);
  }
  translate = (key, fallback) => this.props.localeContext?.translate?.(key, fallback) || fallback || key;
  //MARK:-  APIs Method 
  loadConfigApi = async () => {
    const responseJson = await networkService.networkCall(
      APPURL.URLPaths.config + '?key_group=general',
      'get','', '',
    );
    this.setState({currencyArray: []});
    if (responseJson['status'] == true) {
      var configs = responseJson['data']['configs'];
      this.setState({
        androidVersion: readAppCustomizationDraft('forceUpdate').androidVersion ?? configs['app_android_version'] ?? '',
        iosVersion: readAppCustomizationDraft('forceUpdate').iosVersion ?? configs['app_ios_version'] ?? '',
        // switchValue: configs['force_to_update'] || false ,
      });
    }
    this.setState({dataLoad: true});
  };
  addOrUpdateAppDetailApi = async () => {
    var configs = [];
    let valueArray = [
      this.state.androidVersion,
      this.state.iosVersion,
      // this.state.switchValue,
    ];
    // var configs = [];
    for (let i = 0; i < keysArray.length; i++) {
      if (valueArray[i].length != 0) {
        let fDict = {
          key_group: KeyGroup,
          key: keysArray[i],
          value: valueArray[i],
          secured: false,
        };
        configs.push(fDict);
      }
    }
    const responseJson = await networkService.networkCall(
      APPURL.URLPaths.config,
      'post',
      JSON.stringify({configs: configs}),
      '',
    );
    this.setState({dataLoad: true});
    if (responseJson['status'] == true) {
      clearAppCustomizationDraft('forceUpdate');
      this.deleteKeysAPI(configs);
      // this.alertView('Uploaded successfully');
    } else {
      this.setState({dataLoad: true});
      this.alertView(responseJson);
    }
  };
  deleteKeysAPI = async Parameter => {
    var deleteParms = [];
    for (let q = 0; q < keysArray.length; q++) {
      deleteParms.push(keysArray[q]);
    }
    for (let a = 0; a < Parameter.length; a++) {
      let name = Parameter[a]['key'];
      let index = deleteParms.indexOf(name);
      deleteParms.splice(index, 1);
    }
    if (deleteParms.length != 0) {
      let parms = deleteParms.toString();
      let urlParm = APPURL.URLPaths.config + '?key=' + parms;
      const responseJson = await networkService.networkCall(
        urlParm,
        'delete',
        '',
        '',
      );
      this.setState({dataLoad: true});
      this.alertView('Uploaded successfully');
    } else {
      this.setState({dataLoad: true});
      this.alertView('Uploaded successfully');
    }
  };

  alertView(title) {
    if (Platform.OS === 'web') {
      // alert(title);
      AppToast();
    } else {
      Alert.alert(title);
    }
  }

  //MARK:-  Buttons Action Method 
  saveBtnAction() {
    this.setState({dataLoad: false});
    this.addOrUpdateAppDetailApi();
  }
  switchSattusBtnAction() {
    this.setState({switchValue: !this.state.switchValue});
  }

  render() {
    //this.props.navigation.closeDrawer();
    console.log('', this.state.updateUI);
    return (
      <SafeAreaView style={styles.Container}>
        <View style={{flexDirection: 'column'}}>
          <View style={appConfigStyle.mainView}>
            <Text style={tableStyle.listTitleText}>{this.translate('app_customization.force_update', 'Force To Update')}</Text>
            <Text style={appConfigStyle.subTitleStyle}>
              {this.translate('app_customization.realtime_config_notice', AppConstants.plainTextString)}
            </Text>
            <View style={appConfigStyle.subViewStyle}>
              <View style={{flexDirection: 'column', flex: 1.5}}>
                <View style={{marginTop: 16}}>
                  <Text style={appConfigStyle.titleTxtStyle}>
                    {this.translate('app_customization.android_version', 'Android app version')}
                  </Text>
                  <TextInput
                    value={this.state.androidVersion}
                    style={[appConfigStyle.txtFieldStyle,{outline:0}]}
                    placeholder={this.translate('app_customization.enter_android_version', 'Enter android app version')}
                    onChangeText={name => this.setState({androidVersion: name})}
                  />
                </View>
                <View style={{marginTop: 16}}>
                  <Text style={appConfigStyle.titleTxtStyle}>
                    {this.translate('app_customization.ios_version', 'iOS app version')}
                  </Text>
                  <TextInput
                    value={this.state.iosVersion}
                    style={[appConfigStyle.txtFieldStyle,{outline:0}]}
                    placeholder={this.translate('app_customization.enter_ios_version', 'Enter iOS app version')}
                    onChangeText={name => this.setState({iosVersion: name})}
                  />
                </View>
              </View>
              <View style={appConfigStyle.lineViewStyle} />
              <View style={{flexDirection: 'column', flex: 1}} />
            </View>
          </View>
        </View>
        <Appload enable={this.state.dataLoad} />
      </SafeAreaView>
    );
    //}
  }
}
const styles = StyleSheet.create({
  Container: {
    flex: 1,
    backgroundColor: 'var(--color-surface)',
  },
});

const keysArray = ['app_android_version', 'app_ios_version'];
// const keysArray = ['app_android_version', 'app_ios_version', 'force_to_update'];
